import * as types from "../types/index";
import { setInitialState } from "../InitialState";


const INITIAL_STATE = setInitialState({
    data: null,
});


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.ORGANISATION_ADMIN_DETAILS_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.ORGANISATION_ADMIN_DETAILS_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                data: action.payload.success
            };
        case types.ORGANISATION_ADMIN_DETAILS_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                isSuccess: false,
                data: action.payload.response,
            };
        case types.RESET_ORGANISATION_ADMIN_DETAILS:
            return {
                ...state,
                isFetching: false,
                isError: false,
                data: null,
            };
        default:
            return {
                ...state
            }
    }
}